import { render } from "./contact.vue?vue&type=template&id=29f455e0&scoped=true"
import script from "./contact.vue?vue&type=script&lang=js"
export * from "./contact.vue?vue&type=script&lang=js"

import "./contact.vue?vue&type=style&index=0&id=29f455e0&scoped=true&lang=css"

import exportComponent from "/Users/mac/Documents/GitHub/cristhianVeAl_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29f455e0"]])

export default __exports__